const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the survey searchbar component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('contentSurveySearchbar', ['Surveys', '$q', function (Surveys, $q) {
  return {
    restrict: 'E',
    scope: {
      startItems: '=',
      onChange: '&',
      selectionLimit: '@',
      clear: '='
    },
    template: require('../../templates/directives/content-survey-searchbar.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.queries = [];
      self.updateQuery = function () {
        $scope.onChange({items: self.queries});
      };
      self.given = {
        parse: function () {
          if (!$scope.startItems || !$scope.startItems.length) {
            return;
          }
          var promises = [];
          for (var i = 0; i < $scope.startItems.length; i++) {
            var id = $scope.startItems[i].survey_id || null;
            if (!id || typeof id !== 'string') {
              continue;
            }
            // TODO update this to list if we allow multiple
            var promise = Surveys.get({subresource: id}).$promise;
            if (!promise) {
              continue;
            }
            promises.push(promise)
          }
          $q.all(promises).then(function(items) {
            for (var i = 0; i < items.length; i++) {
              self.queries.push({
                name: items[i].title,
                text: items[i].title,
                _id: items[i]._id,
                type: 'survey'
              });
            }
          });
        }
      };
      // ------------- start ngTag triggered actions ------------
      self.tagInput = {
        addingTag: function ($tag) {
          if (!$tag._id || !$tag.type || !$tag.name) {
            return false;
          }
          if ($scope.selectionLimit) {
            if (self.queries.length && self.queries.length >= $scope.selectionLimit) {
              self.queries.splice(0, 1);
            }
          }
          return true;
        },
        addedTag: function ($tag, outside) {
          self.updateQuery();
        },
        removedTag: function ($tag) {
          self.updateQuery();
        },
        clear: function (outside) {
          self.queries.splice(0);
          if (!outside) {
            self.updateQuery();
          }
        }
      };
      // ------------- End ngTag triggered actions ------------

      self.getOptions = function (input) {
        if (!initClosed) {
          initClosed++;
          initWatch();
        }
        var deferred = $q.defer();

        input = input ? input.toLowerCase() : '';

        var contentQuery = {
          subresource: '',
          page: 0,
          perPage: 6,
          query: {term: input}
        };

        var surveysPromise = Surveys.list(contentQuery).$promise;

        $q.all([surveysPromise])
        .then(function (results) {
          var items = [];
          for (var i = 0; i < results.length; i++) {
            if (!results[i] || !results[i].length) {
              continue;
            }
            for (var j = 0; j < results[i].length; j++) {
              items.push({
                name: results[i][j].title || results[i][j].name,
                text: results[i][j].title || results[i][j].name,
                _id: results[i][j]._id,
                type: 'survey'
              });
            }
          }
          deferred.resolve(items);
        }).catch(function (error) {
          // error messaging
        });

        return deferred.promise;
      };

      var initClosed = 0;
      var initWatch = $scope.$watch('startItems', function(newVal, oldVal) {
        if (newVal) {
          self.given.parse();
          initWatch();
        }
      });
      $scope.$watch('clear', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          self.tagInput.clear(true);
          $scope.clear = false;
        }
      });
    }],
    controllerAs: 'search'
  }
}]);
